import {forwardRef, useEffect, useState} from "react";
import {getImagePathWithTheme, isNumber} from "../utils";
import {DEFAULT_FONT_SIZE, DEFAULT_MAX_FONT_SIZE} from "../../@excalidraw/packages/excalidraw/constants";
import {KEYS} from "../../@excalidraw/packages/excalidraw/keys";
import { ConfigProvider } from "antd";
import {DEFAULT_TIPTAP_FONT_SIZE} from "@/Const";

const InputNumberExt = forwardRef((props:{defaultValue?:any, value?:any, onValueChanged:any},ref)=> {
    const [fontSize, setFontSize] = useState<any>(props.value);

    // 支持受控模式
    // const currentValue = props.value !== undefined ? props.value : fontSize;
    useEffect(() => {
        setFontSize(props.value);
    }, [props.value]);

    const onUpdateValue = (nFontSize:any)=>{
        props.onValueChanged(nFontSize);
    }

    return <div className='flex-row-vertical-center'
                style={{
                    borderRadius: '8px',
                    border: '0px solid var(--input-border-color)',
                    width: '40px',
                    height: '30px'
                }}>
        <ConfigProvider
            theme={{
                components: {
                    InputNumber: {
                        /* 这里是你的组件 token */
                        handleVisible: false
                    },
                },
            }}
        >

            <input
                className='default-font-size input-center input-none hovered-border-blue'
                style={{
                    width: '32px',
                    height: '26px',
                    borderRadius: '4px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    padding: '0px',
                    margin: '0px',
                    background: 'transparent',
                }}
                value={fontSize}
                onChange={(event) => {
                    if (isNumber(event.currentTarget.value) || event.currentTarget.value == '') {
                        setFontSize(event.currentTarget.value);
                    }
                }}

                onFocus={(event => {
                    // mInputValue = parseInt(event.currentTarget.value)
                    // if (isNaN(mInputValue)) {
                    //     mInputValue = 0;
                    // }
                    event.currentTarget.select();
                })}
                onBlur={(event => {
                    onUpdateValue(event.currentTarget.value || DEFAULT_TIPTAP_FONT_SIZE);
                })}
                onKeyDown={(event => {
                    if (event.key === KEYS.ENTER) {
                        event.stopPropagation();
                        event.preventDefault();
                        if (!isNumber(event.currentTarget.value)) {

                        } else {
                            setTimeout(() => {
                                setFontSize(event.currentTarget.value)
                            }, 10)
                        }
                        event.currentTarget.blur();
                    }
                })}></input>

            <div className={'flex-col'}>
                <div className='flex-center'
                     style={{width: '10px', borderLeft: '0px solid var(--home-left-border-color)', height: '6px'}}
                     onClick={() => {
                         let nFontSize = Number(fontSize) + 1;
                         setFontSize(nFontSize);
                         onUpdateValue(nFontSize);
                     }}>
                    <img className={'action-property-'} style={{width: '10px', height: '6px'}}
                         src={getImagePathWithTheme('tra_up.svg', true)}/>
                </div>
                <div className='flex-center'
                     style={{
                         width: '10px',
                         borderRight: '0px solid var(--home-left-border-color)',
                         height: '6px',
                         marginTop: '2px'
                     }}
                     onClick={() => {
                         let nFontSize = Number(fontSize) - 1
                         if (nFontSize <= 0) {
                             nFontSize = 1;
                         }
                         setFontSize(nFontSize);
                         onUpdateValue(nFontSize);
                     }}>
                    <img style={{width: '10px', height: '6px'}} src={getImagePathWithTheme('tra_down.svg', true)}/>
                </div>
            </div>

        </ConfigProvider>

        {/*<img className='img-mini-small-12' src={imgPathPerfix()+"drop_down_gray.png"}/>*/}
    </div>
})

export default InputNumberExt;